import { keyPicker, tagAs } from 'factions/metatagger'
import { GenericEffects } from 'generic_rules'
import {
  BATTLESHOCK_PHASE,
  CHARGE_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  DURING_ROUND,
  DURING_SETUP,
  END_OF_ANY_PHASE,
  END_OF_CHARGE_PHASE,
  END_OF_COMBAT_PHASE,
  END_OF_HERO_PHASE,
  END_OF_MOVEMENT_PHASE,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SAVES_PHASE,
  SHOOTING_PHASE,
  START_OF_COMBAT_PHASE,
  START_OF_HERO_PHASE,
  START_OF_MOVEMENT_PHASE,
  START_OF_ROUND,
  WARDS_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'
import command_abilities from './command_abilities'
import rule_sources from './rule_sources'
import scenery from './scenery'
import spells from './spells'
import monstrous_rampages from './monstrous_rampages'
import { TItemDescriptions } from 'factions/factionTypes'

/* const BlessingsOfTheForestEffect = {
  name: `Blessings of the Forest`,
  desc: `Subtract 1 from hit rolls and wound rolls for attacks that target this unit if it is wholly within 9" of any overgrown or friendly AWAKENED WYLDWOODS.`,
  when: [SHOOTING_PHASE, COMBAT_PHASE],
  shared: true,
}

const TreeLordBaseEffects = [
  {
    name: `Spirit Paths`,
    desc: `At the start of your movement phase, if this unit is wholly within 6" of an overgrown terrain or Awakened Wyldwood in your army, it can walk the spirit paths instead of making a move in that phase. If it does so, remove this unit from the battlefield and set it up wholly within 6" of a different overgrown terrain or AWAKENED WYLDWOOD in your army and more than 9" from any enemy units.`,
    when: [START_OF_MOVEMENT_PHASE],
    shared: true,
  },
]

const BugRiderEffects = [
  {
    name: `Champion`,
    desc: `1 model in this unit can be a champion. Add 1 to the Attacks characteristic of that model's melee weapons, this has no effect on the mount.`,
    when: [COMBAT_PHASE],
    shared: true,
  },
  {
    name: `Banner Bearer`,
    desc: `1 in every 3 models in this unit can be a Banner bearer. This unit can pile-in up to 6" instead of 3" while it includes any Standard Bearers.`,
    when: [COMBAT_PHASE],
    shared: true,
  },
  {
    name: `Musician`,
    desc: `1 in every 3 models in this unit can be a Hornblower. When this unit receives the Rally command it can return 1 slain model for each roll of 5+ instead of only 6 while it includes any Hornblowers.`,
    when: [START_OF_HERO_PHASE],
    shared: true,
  },
  {
    name: `Thrumming with Life`,
    desc: `At the end of each phase, if any enemy models were slain by an attack made by this unit in that phase, you can heal all wounds allocated to this unit.`,
    when: [DURING_GAME, WOUND_ALLOCATION_PHASE],
    rule_sources: [rule_sources.BATTLETOME_SYLVANETH, rule_sources.ERRATA_OCTOBER_2022],
    shared: true,
  },
]
const WarmasterEffect = {
  name: `Warmaster`,
  desc: `If this unit is included in a Sylvaneth army, it is treated as a general even if it is not the model picked to be the army's general.`,
  when: [DURING_GAME],
  shared: true,
} */

const Units = {
  'Alarielle The Everqueen': {
    /* mandatory: {
      spells: [keyPicker(spells, ['Metamorphosis'])],
    }, */
    effects: [
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Wardroth Beetle's Antlers is 4.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Lifebloom - Once Per Turn`,
        desc: `Effect: Heal (2D6) this unit.`,
        when: [HERO_PHASE],
      },
      {
        name: `Metamorphosis: Casting value of 7`,
        desc: `Declare: Pick a visible enemy unit within 12" of this unit to be the target, then make a casting roll of 2D6. 
        Effect: Inflict 2D3 mortal damage on the target. If the target would be destroyed by this spell, before removing any models, pick the closest terrain feature to the target that does not have a friendly overgrown token and give it a friendly overgrown token. If all terrain features on the battlefield already have a friendly overgrown token, inflict D3 mortal damage on each enemy unit within 6" of the target instead.`,
        when: [HERO_PHASE],
      },
      {
        name: `Living Battering Ram - Once Per Turn`,
        desc: `Declare: If this unit charged this turn, pick a visible enemy unit within 1" of it to be the target. 
        Effect: Roll a dice. On a 3+, inflict an amount of mortal damage on the target equal to the roll.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Command Ability(2): The Goddess of Life - Once Per Battle`,
        desc: `Declare: This unit can use this ability even if it has been destroyed. 
        Effect: Set up a replacement unit with 8 damage points allocated to it (ward rolls cannot be made for those damage points) wholly within the creeping overgrowth and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Seasons of War`,
        desc: `Declare: You must use this ability.
        Effect: Pick 1 of the following effects to apply for the rest of the battle round. You cannot pick the effect that you picked in the previous battle round.
        The Burgeoning: Each time a friendly Awakened Wyldwood uses the 'Ever Growing' ability, you can pick any terrain feature your opponent does not control to be the target rather than the closest.
        The Reaping: Add 1 to casting rolls and chanting rolls for friendly Sylvaneth units while they are wholly within 12" of this unit.
        The Dwindling: Friendly Sylvaneth units can use Charge abilities even if they used a Retreat ability in the same turn. In addition, no mortal damage is inflicted on those units when they use Retreat abilities.
        Everdusk: Each time you use the 'Creeping Dread' ability this battle round, you can pick up to 3 targets instead of 1.`,
        when: [START_OF_ROUND],
      },
    ],
  },
  'Drycha Hamadreth': {
    effects: [
      {
        name: `Terror of the Deepwoods - Passive`,
        desc: `Effect: Enemy units cannot use Run or Retreat abilities while they are within 9" of this unit.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Merciless Ambush`,
        desc: `Effect: Pick 1 of the following effects to apply to this unit for the rest of the turn: 
        Effect: If this unit is not in combat and has not used a Run or Retreat ability this turn, make a charge roll of 2D6. Then, remove this unit from the battlefield and set it up again within ½" of an enemy unit and wholly within X" of a terrain feature that has a friendly overgrown token, where X is equal to the charge roll. If you do so, this unit has charged.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Enrage the Spites: Casting value of 7`,
        desc: `Declare: Pick up to 3 enemy units that are visible to and within 12" of this unit or that are within the creeping overgrowth to be the targets, then make a casting roll of 2D6. 
        Effect: Inflict D3 mortal damage on each target.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Drycha Hamadreth (SoG)': {
    effects: [
      {
        name: `Strength from Spite - Passive`,
        desc: `Effect: Ward rolls cannot be made for damage points inflicted by this units attacks.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Twisted Spirit-Song: Casting value of 6`,
        desc: `Declare: Pick a visible friendly Sylvaneth unit wholly within 12" of this unit to be the target. Then, make a casting roll of 2D6. 
        Effect: Until the start of your next turn, add 1 to wound rolls for the targets combat attacks, including those made with Companion weapons. 
        In addition, if the target is non-Kurnothi, add 1 to the Attacks characteristics of the targets melee weapons.`,
        when: [HERO_PHASE],
      },
      {
        name: `Vicious Spiteswarms - Reaction: Opponent declared a Charge ability for a unit within 18" of this unit`,
        desc: `Effect: Your opponent must pick 1 of the following: 
        Avoid the Swarm: Subtract D3 from the charge roll. In addition, if your opponent rerolls that charge roll, subtract D3 from that roll. 
        Charge Through the Swarm: Subtract 1 from hit rolls for that units attacks for the rest of the turn, and add 1 to hit rolls for attacks that target that unit for the rest of the turn.`,
        when: [CHARGE_PHASE],
      },
    ],
  },
  'Grove Guardian': {
    effects: [
      {
        name: `Soulshriek - Passive`,
        desc: `Effect: Each time a model in a friendly non-Hero Revenant unit wholly within 12" of and visible to this unit is slain by a combat attack and that model was in combat with the attacking unit, roll a number of dice equal to the slain model's Health characteristic. For each 5+, inflict 1 mortal damage on the attacking unit after the Fight ability has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Regenesis: Chant value of 4`,
        desc: `Declare: Pick a friendly Sylvaneth unit that is wholly within the creeping overgrowth or that is visible to and wholly within 12" of this unit to be the target, then make a chanting roll of D6. 
        Effect: If the chanting roll was 6+, you can pick another eligible unit to be a second target. If a target is a Revenant Infantry or Dryads unit, return up to D3 models to that target unit. Otherwise, Heal (3) that target.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Spirit of Durthu': {
    effects: [
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Guardian Sword is 3.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Guardian of the Glades - Once Per Turn - Reaction: You declared a Charge ability for this unit`,
        desc: `Effect: Add 2 to the charge roll but this unit must end that charge move within 1/2" of an enemy unit that is in combat with another friendly Sylvaneth Hero.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Groundshaker - Once Per Turn`,
        desc: `Declare: Pick an enemy non-Fly Infantry or Cavalry unit in combat with this unit to be the target.
        Effect: Roll a dice. On a 3+, the target has Strike-Last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Treelord Ancient': {
    effects: [
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Sweeping Blows is 3.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Eldest of Elders - Once Per Turn`,
        desc: `Declare: Pick each friendly Forest Elder within this unit's combat range to be the targets. 
        Effect: Roll a dice for each target. On a 3+, add 1 to hit rolls for that target's combat attacks until the start of your next turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Awaken Slumbering Spirits - Once Per Turn`,
        desc: `Declare: Pick a visible terrain feature that has a friendly overgrown token and is within 12" of this unit. Then, pick a friendly non-Unique Kurnothi or Treelord unit that has been destroyed to be the target.
        Effect: Set up a replacement unit with 1 model from the target unit wholly within 6" of that terrain feature and more than 9" from all enemy units. Then, remove the friendly overgrown token from that terrain feature. If the target was a Treelord, allocate 10 damage points to the replacement unit (ward rolls cannot be made for those damage points).`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  Treelord: {
    effects: [
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Sweeping Blows is 3.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Lash and Tangle - Once Per Turn`,
        desc: `Declare: Pick an enemy unit that had any damage points allocated to it this turn by attacks made with this unit's Strangleroots to be the target.
        Effect: Roll a dice. Add 1 to the roll if the target is within the creeping overgrowth. On a 3+, subtract 1 from hit rolls for the target's attacks until the start of your next turn.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Strangling Grasp - Once Per Turn`,
        desc: `Declare: Pick a visible enemy unit within 10" of this unit to be the target. 
       Effect: Roll a dice. If the roll exceeds the target's Health characteristic, 1 model in the target unit is slain.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Arch-Revenant': {
    effects: [
      {
        name: `Gossamid Commander - Once Per Turn`,
        desc: `Declare: If this unit charged this turn, pick a visible friendly Gossamid Archers unit that is not in combat and is wholly within 18" of this unit to be the target.
        Effect: The target can immediately use a Shoot ability as if it were your shooting phase but all of the attacks made as part of that Shoot ability must target an enemy unit that is in combat with this unit.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Fight and Fly - Reaction: You declared a Fight ability for this unit`,
        desc: `Effect: If this unit charged this turn, this unit can move up to 2D6" after that Fight ability has been resolved. It cannot end that move in combat.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'The Lady of Vines': {
    effects: [
      {
        name: `Hand of the Everqueen - Once Per Turn`,
        desc: `Declare: Pick a terrain feature within 18" of this unit that has a friendly overgrown token to be the target.
        Effect: Measure the range and visibility of the next Spell ability used by this unit this phase from the target instead of from this unit, and your opponent can measure range and visibility to that terrain feature instead of this unit for the purposes of the 'Unbind' ability.`,
        when: [HERO_PHASE],
      },
      {
        name: `Protection of the Everqueen: Casting value of 7`,
        desc: `Declare: Make a casting roll of 2D6. Add 1 to the roll if this unit is wholly within the creeping overgrowth.
        Effect: Until the start of your next turn, friendly Sylvaneth units have Ward (5+) while they are wholly within 12" of this unit.`,
        when: [HERO_PHASE],
      },
      {
        name: `Verdian Crown - Once Per Battle`,
        desc: `Declare: Pick a terrain feature within 18" of this unit that does not have a friendly overgrown token to be the target.
        Effect: Give the target a friendly overgrown token.`,
        when: [HERO_PHASE],
      },
    ],
  },
  Branchwych: {
    effects: [
      {
        name: `Slay the Trespassers! - Once Per Turn`,
        desc: `Declare: Pick an enemy unit that is within the creeping overgrowth or that is visible to this unit and within friendly territory to be the target.
        Effect: Roll a dice. On a 3+, add 1 to wound rolls for combat attacks that target that enemy unit for the rest of the turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  /* Ylthari: {
   /* mandatory: { spells: [keyPicker(spells, ['The Reaping'])] }, 
    effects: [
      {
        name: `Vigour and Wrath`,
        desc: `You can reroll wound rolls of 1 for attacks made by this model.`,
        when: [COMBAT_PHASE],
      },
      GenericEffects.WizardOneSpellEffect,
    ],
  },
  "Ylthari's Guardians": {
    effects: [
      {
        name: `Martial Memories`,
        desc: `Once per turn, this unit can receive the All-out Attack or All-out Defence command without the command being issued and without a command point being spent.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
      {
        name: `Vigour and Wrath`,
        desc: `You can reroll wound rolls of 1 for attacks made by this unit.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
    ],
  },*/
  'Tree-Revenants': {
    effects: [
      {
        name: `Warriors of the Woods - Passive`,
        desc: `Effect: While this unit is in combat and has not charged this turn, add 1 to the Damage characteristic of this unit's melee weapons.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Spite-Revenants': {
    effects: [
      {
        name: `Shadowcreep - Once Per Turn`,
        desc: `Effect: If this unit is wholly within the creeping overgrowth, remove this unit from the battlefield and set it up again wholly within 3" of a terrain feature and more than 9" from all enemy units. Then, add 1 to charge rolls for this unit for the rest of the turn.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'Kurnoth Hunter Greatswords': {
    effects: [
      {
        name: `Hunters Endurance - Passive`,
        desc: `Effect: Subtract 1 from the Rend characteristic of weapons used for attacks that target this unit while it is wholly within the creeping overgrowth.`,
        when: [DURING_GAME],
      },
      {
        name: `Crashing Impact`,
        desc: `Declare: If this unit charged this turn, pick an enemy unit in combat with it to be the target. 
        Effect: Roll a dice for each model in this unit that is in combat with the target. For each 3+, inflict 1 mortal damage on the target.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Kurnoth Hunter Scythes': {
    effects: [
      {
        name: `Hunters Endurance - Passive`,
        desc: `Effect: Subtract 1 from the Rend characteristic of weapons used for attacks that target this unit while it is wholly within the creeping overgrowth.`,
        when: [DURING_GAME],
      },
      {
        name: `Tanglethorn Thicket`,
        desc: `Declare: Pick an enemy unit that charged this turn and is in combat with this unit to be the target.
        Effect: Roll a dice for each model in this unit that is in combat with the target. For each 3+, inflict 1 mortal damage on the target.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Kurnoth Hunter Greatbows': {
    effects: [
      {
        name: `Hunters Endurance - Passive`,
        desc: `Effect: Subtract 1 from the Rend characteristic of weapons used for attacks that target this unit while it is wholly within the creeping overgrowth.`,
        when: [DURING_GAME],
      },
      {
        name: `Steady Aim - Once Per Turn`,
        desc: `Effect: If this unit has not used a Move ability this turn and was not set up this turn, add 1 to hit rolls for this unit's shooting attacks for the rest of the turn.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
  Dryads: {
    effects: [
      {
        name: `One with the Forest - Passive`,
        desc: `Effect: Subtract 1 from hit rolls and wound rolls for attacks that target this unit while it is wholly within the creeping overgrowth.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
      // BlessingsOfTheForestEffect,
    ],
  },
  'Warsong Revenant': {
    effects: [
      {
        name: `Alarielle's Song - Passive`,
        desc: `Effect: Friendly Sylvaneth units have Ward (6+) while they are wholly within 12" of this unit. Subtract 1 from ward rolls for enemy units while they are within 12" of this unit.`,
        when: [DURING_GAME],
      },
      {
        name: `Rousing Accompaniment - Once Per Turn - Reaction: You made an unmodified chanting roll of 1 for a Sylvaneth Priest wholly within 12" of this unit`,
        desc: `Effect: Re-roll that chanting roll.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Spiterider Lancers': {
    effects: [
      {
        name: `Forest Fighters - Passive`,
        desc: `Effect: This unit has a coherency range of 2".`,
        when: [DURING_GAME],
      },
      {
        name: `Strike and Fade - Once Per Turn`,
        desc: `Effect: If this unit charged this turn, remove it from the battlefield and set it up again more than 9" from all enemy units and wholly within the creeping overgrowth.`,
        when: [END_OF_TURN],
      },
    ],
  },
  'Revenant Seekers': {
    effects: [
      {
        name: `Forest Fighters - Passive`,
        desc: `Effect: This unit has a coherency range of 2".`,
        when: [DURING_GAME],
      },
      {
        name: `Deafening Drone - Once Per Turn`,
        desc: `Declare: If this unit did not charge this turn, pick an enemy unit in combat with it to be the target.
        Effect: Subtract 1 from the Attacks characteristic of the target's melee weapons for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Revenant Seekers (SoG)': {
    effects: [
      {
        name: `Forest Fighters - Passive`,
        desc: `Effect: This unit has a coherency range of 2".`,
        when: [DURING_GAME],
      },
      {
        name: `Lamentiri Life Energies - Once Per Turn`,
        desc: `Declare: Pick a visible friendly Sylvaneth unit wholly within 12" of this unit to be the target. 
        Effect: Roll a dice. On a 3+, the target has Ward (5+) for the rest of the turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'The Twistweald': {
    effects: [
      {
        name: `Latching Paraspites - Once Per Turn`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target.
        Effect: The target has the Infested keyword for the rest of the battle. Infested enemy units cannot move more than 6" when using non-Charge Move abilities.`,
        when: [END_OF_TURN],
      },
      {
        name: `Pain-Induced Frenzy - Passive`,
        desc: `Effect: This unit's melee weapons have Crit (2 Hits) if it charged in the same turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Gossamid Archers': {
    effects: [
      {
        name: `Forest Fighters - Passive`,
        desc: `Effect: This unit has a coherency range of 2".`,
        when: [DURING_GAME],
      },
      {
        name: `Zephyrspites - Reaction: You declared a Shoot ability for this unit`,
        desc: `Effect: After that Shoot ability has been resolved, this unit can move up to D6". It cannot move into combat during any part of that move.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
  Belthanos: {
    effects: [
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Carnelian Greatspites Mandibles is 3.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Huntmasters Strike - Once Per Turn`,
        desc: `Effect: If this unit charged this turn, remove it from the battlefield and set it up again more than 6" from all enemy units and wholly within the creeping overgrowth.`,
        when: [END_OF_TURN],
      },
      {
        name: `Rhythm of the Chase - Once Per Turn`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target.
        Effect: Roll a D3. On a 2+, inflict an amount of mortal damage on the target equal to the roll, then you can remove this unit from the battlefield and set it up again within 1" of the target.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Kurnothi War-horn - Passive`,
        desc: `Effect: Add 2" to the Move characteristic of friendly Kurnothi units while they are wholly within 12" of this unit.`,
        when: [MOVEMENT_PHASE],
      },
    ],
  },
  'ROR: Fjori`s Flamebearers': {
    /* mandatory: {
       prayers: [keyPicker(prayers, ['Vessel of Sigmar'])],
     }, */
    effects: [
      {
        name: `Grimhold Exile: Last of the Lodge-fire - Once Per Battle`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target. 
        Effect: Roll a number of dice equal to the targets Health characteristic. For each 4+, inflict 1 mortal damage on the target.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Grimhold Exile: Honour to Grimnir! - Once Per Battle`,
        desc: `Declare: Pick up to 3 friendly Fyreslayers Infantry units wholly within 12" of this unit to be the targets. 
        Effect: You can reroll charge rolls for the targets for the rest of the turn`,
        when: [HERO_PHASE],
      },
      {
        name: `Auric Hearthguard: Molten Rockbolts - Passive`,
        desc: `Effect: Each time a shooting attack made by this unit scores a critical hit, subtract 1" from the target units Move characteristic until the start of your next turn. This ability cannot reduce the target units unmodified Move characteristic below half.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Hearthguard Berzerkers: Duty Unto Death - Passive`,
        desc: `Effect: While any friendly Fyreslayers Infantry Heroes are wholly within this units combat range, both this unit and those friendly units have Ward (5+).`,
        when: [DURING_GAME],
      },
      {
        name: `Hearthguard Berzerkers with Poleaxes: Smouldering Braziers`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target. 
        Effect: Roll a D3. On a 2+, inflict an amount of mortal damage on the target equal to the roll.`,
        when: [END_OF_TURN],
      },
      {
        name: `Hearthguard Berzerkers with Broadaxes: Fires of Vengeance - Passive`,
        desc: `Effect: While this unit is within the combat ranges of any damaged friendly Fyreslayers Heroes, add 1 to the Attacks characteristic of this unit's melee weapons.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Vulkite Berzerkers with Slingshields: Berserk Fury - Passive`,
        desc: `Effect: Each time a model in this unit is slain by a combat attack and that model was in combat with the attacking unit, roll a dice. On a 5+, inflict 1 mortal damage on the attacking unit aer the Fight ability has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Vulkite Berzerkers with Handaxes: Whirlwind of Destruction - Passive`,
        desc: `Effect: Add 1 to the Attacks characteristic of this units melee weapons if this unit charged this turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Toe to Toe - Passive`,
        desc: `Effect: Subtract 10 from the control scores of enemy Monsters while they are in combat with any units in this Regiment of Renown.`,
        when: [END_OF_TURN],
      },
      {
        name: `Grimnir's Defiance - Passive`,
        desc: `Effect: Units in this Regiment of Renown cannot be picked to be the target of Rampage abilities used by enemy units.`,
        when: [DURING_GAME],
      },
    ],
  },
  'ROR: Saviours of Cinderfall': {
    /* mandatory: {
       prayers: [keyPicker(prayers, ['Vessel of Sigmar'])],
     }, */
    effects: [
      {
        name: `Callis and Toll: Right Tools for the Job - Passive`,
        desc: `Effect: Double the Damage characteristic of this units weapons for attacks that target Wizards, Priests and Manifestations.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
      {
        name: `Callis and Toll: Wily to the Last - Passive`,
        desc: `Effect: If this unit has 2 models and would be automatically destroyed, it is not automatically destroyed. Instead, 1 model in this unit is slain.`,
        when: [DURING_GAME],
      },
      {
        name: `Callis and Toll: Get it Done - Reaction: You declared a Fight ability for this unit`,
        desc: `Effect: Pick a friendly Tolls Companions unit that has not used a Fight ability this turn and is within this units combat range to be the target. The target can be picked to use a Fight ability immediately after the Fight ability used by this unit has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Toll's Companions: Hidden Agents`,
        desc: `Declare: Pick this unit and a friendly Callis and Toll unit in the same regiment as this unit if those units have not been deployed. 
        Effect: Set up those units in reserve in the shadows. Those units have now been deployed.`,
        when: [DURING_SETUP],
      },
      {
        name: `Toll's Companions: Saviours of Cinderfall - Passive`,
        desc: `Effect: While a friendly Callis and Toll unit is wholly within this units combat range, both this unit and that Callis and Toll unit have Ward (5+).`,
        when: [DURING_GAME],
      },
      {
        name: `Toll's Companions: Emerge from the Shadows`,
        desc: `Declare: Pick this unit if it is in the shadows. 
         Effect: Set up this unit anywhere on the battlefield more than 9" from all enemy units. Then, set up the Callis and Toll unit that was set up in the shadows with this unit wholly within 6" of it and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Duty Bound - Passive`,
        desc: `Effect: While every model in the same unit in the Regiment of Renown is contesting the same objective, add 1 to save rolls and ward rolls for that unit.`,
        when: [DURING_GAME],
      },
      {
        name: `Sigmar's Justice - Once Per Turn`,
        desc: `Declare: Pick an enemy unit to be marked for justice. You can pick a unit that is in reserve. 
         Effect: For the rest of the battle, add 1 to wound rolls for combat attacks made by units in this Regiment of Renown that target a unit that is marked for justice.`,
        when: [DURING_SETUP],
      },
    ],
  },
  'ROR: Norgrimm`s Rune Throng': {
    /* mandatory: {
       prayers: [keyPicker(prayers, ['Vessel of Sigmar'])],
     }, */
    effects: [
      {
        name: `Runelord: Runes of Spellbreaking - Passive`,
        desc: `Effect: This unit can use the Unbind ability as if it had Wizard (1).`,
        when: [HERO_PHASE],
      },
      {
        name: `Runelord: Forgefire: Chant value of 5`,
        desc: `Declare: Pick a friendly Cities of Sigmar Duardin unit wholly within 12" of this unit to be the target, then make a chanting roll of D6. 
        Effct: Until the start of your next turn, add 1 to the Rend characteristic of the targets melee weapons. In addition, if the chanting roll was 10+, pick another friendly Cities of Sigmar Duardin unit wholly within 12" of this unit. Add 1 to the Rend characteristic of that units melee weapons until the start of your next turn as well.`,
        when: [HERO_PHASE],
      },
      {
        name: `Irondrakes: Cinderblast Bomb - Once Per Turn`,
        desc: `Declare: If this unit is not in combat, pick a visible enemy unit within 6" of it to be the target. 
        Effect: Roll a dice. On a 3+, inflict an amount of mortal damage on the target equal to the roll.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Longbeards: I Thought Duardin Were Made of Sterner Stuff! - Passive`,
        desc: `Effect: Add 2 to the control scores of friendly Cities of Sigmar Duardin units, excluding Longbeards units, while they are wholly within 12" of this unit.`,
        when: [END_OF_TURN],
      },
      {
        name: `Rune of Restored Hearth - Once Per Battle`,
        desc: `Effect: If the Runelord in the Regiment of Renown is contesting an objective, for the rest of the battle, units in this Regiment of Renown have Ward (5+) while they are contesting that objective.`,
        when: [HERO_PHASE],
      },
      {
        name: `Wrath and Ruin: Chant value of 4`,
        desc: `Declare: Pick the Runelord in this Regiment of Renown to chant this prayer, pick a visible enemy unit within 18" of them to be the target, then make a chanting roll of D6. 
         Effect: Roll 6 dice. If the chanting roll was 8+, roll 9 dice instead. For each 5+, inflict 1 mortal damage on the target. If 3 or more damage points are allocated to the target as a result of those dice rolls, ignore positive modifiers to save rolls for the target until the start of your next turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'ROR: Gotrek Gurnisson': {
    effects: [
      {
        name: `Command Ability - Unstoppable Battle Fury`,
        desc: `Effect: This unit can use 2 Fight abilities this phase. After the first is used, however, this unit has Strikelast for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `I'll Get There Myself! - Passive`,
        desc: `Effect: This unit cannot be set up in reserve and cannot be targeted by abilities that would remove it from the battlefield.`,
        when: [DURING_GAME],
      },
    ],
  },
  'ROR: The Blacktalons': {
    effects: [
      {
        name: `Neave Blacktalon: Justice from Azyr`,
        desc: `Effect: Add 1 to the Damage characteristic of this units Whirlwind Axes for attacks that target Heroes.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Neave Blacktalon: Vanguard Chamber - Passive`,
        desc: `Effect: This unit can use Shoot and/or Charge abilities even if it used a Run or Retreat ability in the same turn.`,
        when: [MOVEMENT_PHASE, SHOOTING_PHASE, CHARGE_PHASE],
      },
      {
        name: `Neave Blacktalon: Windrider`,
        desc: `Declare: If this unit is in combat or charged this turn, this unit can make a pile-in move. Then, if this unit is in combat, you must pick 1 or more enemy units to be the target(s) of this units attacks. 
        Effect: Resolve combat attacks against the target unit(s). Then, roll a dice. On a 3+, remove this unit from the battlefield and set it up again on the battlefield more than 3" from all enemy units and wholly within the combat range of a friendly The Blacktalons unit that is not in combat.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Neave's Companions: Shield of Azyr`,
        desc: `Effect: While any friendly The Blacktalons Heroes are wholly within this units combat range, both this unit and those friendly units have Ward (5+).`,
        when: [DURING_GAME],
      },
      {
        name: `Lorai: Aquatic Illusions`,
        desc: `Effect: Subtract 1 from hit rolls for attacks that target this unit.`,
        when: [COMBAT_PHASE, SHOOTING_PHASE],
      },
      {
        name: `Lorai: Nebulous Sea-Fog: Casting value of 6`,
        desc: `Effect: Until the start of your next turn, while a friendly The Blacktalons unit is wholly within 6" of this unit, if the unmodified hit roll for a shooting attack that targets that unit is 1-5, the attack fails and the attack sequence ends.`,
        when: [HERO_PHASE],
      },
      {
        name: `Justice Will Be Served - Once Per Battle`,
        desc: `Declare: Pick the Neave Blacktalon in this Regiment of Renown to be the target if it is in combat with an enemy Hero. 
        Effect: The target can use 2 Fight abilities this phase. Each time it does so, if it is in combat with an enemy Hero, all of its attacks must target an enemy Hero. In addition, after the first Fight ability is used, the target has Strike-last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'ROR: Bundo Whalebiter': {
    effects: [
      {
        name: `Get Orf Me Land! - Once Per Turn`,
        desc: `Declare: Pick an objective within 1" of this unit to be the target. 
        Effect: Roll a dice. On a 2+, move the target 2D6" to a new position on the battlefield more than 1" from all models, terrain features and other objectives.`,
        when: [HERO_PHASE],
      },
      {
        name: `Stuff 'Em In Me Net - Once Per Turn`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target. 
        Effect: Roll 3 dice. For each roll that is at least double the targets Health characteristic, 1 model in the target unit is slain.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Son of Behemat - Passive`,
        desc: `Effect: If this unit would be automatically destroyed, it is not automatically destroyed. Instead, allocate 6 damage points to it (ward rolls cannot be made for those damage points).`,
        when: [DURING_GAME],
      },
      {
        name: `Longshanks - Passive`,
        desc: `Effect: This unit can pass through models in non-Monster units and parts of terrain features that are less than 4" tall.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Battle Damaged - Passive`,
        desc: `Effect: While this unit has 15 or more damage points, the Attacks characteristic of its Shipwrecka Warclub is 3 and this unit has a Control characteristic of 10.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Dead Cunning for a Gargant - Once Per Turn`,
        desc: `Effect: For the rest of the turn, add 1 to the Attacks characteristic of this units weapons. Then, roll a dice. On a 4+, this unit has Strike-last for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Timberrr! - Passive`,
        desc: `Effect: When the Mega-Gargant in this regiment of renown is slain, before removing it from play, the players must roll off. The winner picks a point on the battlefield within 3" of that model. Inflict D3 mortal damage on each unit (friendly and enemy) within 3" of that point that has a lower Health characteristic than that model.`,
        when: [DURING_GAME],
      },
    ],
  },
  'ROR: The Horizon Seekers': {
    effects: [
      {
        name: `Lord-Aquilor: Vanguard Chamber - Passive`,
        desc: `Effect: This unit can use Shoot and/or Charge abilities even if it used a Run or Retreat ability in the same turn.`,
        when: [MOVEMENT_PHASE, SHOOTING_PHASE, CHARGE_PHASE],
      },
      {
        name: `Lord-Aquilor: Ride the Winds Aetheric`,
        desc: `Declare: If this unit is not in combat, you can pick up to 2 friendly Vanguard-Palladors units that are not in combat to be the targets. 
        Effect: Remove this unit and the targets (if any) from the battlefield. Set this unit up again on the battlefield more than 9" from all enemy units. Then, set up each target wholly within 12" of this unit and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Vanguard-Hunters: Vanguard Chamber - Passive`,
        desc: `Effect: This unit can use Shoot and/or Charge abilities even if it used a Run or Retreat ability in the same turn.`,
        when: [MOVEMENT_PHASE, SHOOTING_PHASE, CHARGE_PHASE],
      },
      {
        name: `Vanguard-Hunters: Astral Compass - Once Per Battle`,
        desc: `Declare: Pick an enemy unit to be the target. 
        Effect: The target has the Hunted keyword for the rest of the battle.`,
        when: [DURING_SETUP],
      },
      {
        name: `Vanguard-Hunters: Star-Marked - Passive`,
        desc: `Effect: Add 2" to this units Move characteristic while a Hunted enemy unit is on the battlefield. In addition, add 1 to hit rolls for this units attacks that target a Hunted enemy unit.`,
        when: [MOVEMENT_PHASE, SHOOTING_PHASE, CHARGE_PHASE],
      },
      {
        name: `Vanguard Palladors: Vanguard Chamber - Passive`,
        desc: `Effect: This unit can use Shoot and/or Charge abilities even if it used a Run or Retreat ability in the same turn.`,
        when: [MOVEMENT_PHASE, SHOOTING_PHASE, CHARGE_PHASE],
      },
      {
        name: `Vanguard Palladors with Javelins: Charging Volley`,
        desc: `Declare: If this unit charged this phase, pick an enemy unit in combat with it to be the target. 
        Effect: This unit can immediately use a Shoot ability as if it were your shooting phase, but it must target that enemy unit. This units Starstrike Javelins have Shoot in Combat this phase.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Hunters' Cohesion - Passive`,
        desc: `Effect: Each time this Regiment of Renown's Lord-Aquilor uses its Ride the Winds Aetheric ability, you can pick all units in this Regiment of Renown that are not in combat to be the targets. 
        In addition, add 1 to hit rolls for attacks made by this Regiment of Renown's Lord-Aquilor and Vanguard-Palladors units that target a Hunted enemy unit.`,
        when: [DURING_GAME],
      },
    ],
  },
  'ROR: Valnirs Stormwing': {
    effects: [
      {
        name: `Knight-Draconis: Wrath of the Draconith - Once Per Turn`,
        desc: `Declare: Pick a friendly Stormdrake Guard unit within this units combat range to be the target. 
        Effect: Roll a dice. On a 2+, add 1 to the Attacks characteristic of both this units and the targets Draconiths Fangs and Talons for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Knight-Draconis: Arcane Heritage - Reaction: Opponent declared a Spell ability`,
        desc: `Effect: If this unit or a friendly Stormdrake Guard unit wholly within 12" of this unit was picked to be the target of that spell, roll a dice. On a 4+, ignore the effect of that spell on this unit or that friendly unit. This unit can use this ability more than once per phase but only once per Spell ability.`,
        when: [HERO_PHASE],
      },
      {
        name: `Knight-Draconis: Extremis Chamber - Passive`,
        desc: `Effect: Each time you make an unmodified save roll of 6 for a combat attack that targets this unit, inflict 1 mortal damage on the attacking unit after the Fight ability has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Stormdrake Guard: Extremis Chamber - Passive`,
        desc: `Effect: Each time you make an unmodified save roll of 6 for a combat attack that targets this unit, inflict 1 mortal damage on the attacking unit after the Fight ability has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Hour of Retribution - Once Per Battle`,
        desc: `Effect: For the rest of the turn:
        Add 1 to wound rolls for attacks made by units in this Regiment of Renown.
        Add 1 to save rolls for units in this Regiment of Renwon.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'ROR: Nurgles Gift': {
    effects: [
      {
        name: `Nurglings: Endless Swarm - Passive`,
        desc: `Effect: Heal (3) this unit.`,
        when: [END_OF_TURN],
      },
      {
        name: `Incubation Period`,
        desc: `Declare: This ability must be used to deploy this Regiment of Renown. 
        Effect: Set up the units in this Regiment of Renown in reserve festering within. They have now been deployed.`,
        when: [DURING_SETUP],
      },
      {
        name: `Bursting with Life - Passive`,
        desc: `Effect: If a friendly non-Nurgles Gift unit would be destroyed, before the last model is removed from play, roll a dice. Add 1 to the roll for each other friendly non-Nurgles Gift unit that has been destroyed this battle. On a 5+, pick a friendly unit that is festering within and set it up wholly within 6" of that model. It can be set up in combat.`,
        when: [DURING_GAME],
      },
    ],
  },
  'ROR: Stumblefoot Gargant': {
    effects: [
      {
        name: `Mancrusher Gargant: Stuff 'Em in Me Bag - Once Per Turn`,
        desc: `Declare: Pick an enemy unit in combat with this unit to be the target. 
        Effect: Roll a dice. If the roll is at least double the targets Health characteristic, 1 model in the target unit is slain.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Projectile Vomit - Once Per Turn`,
        desc: `Declare: Pick this unit to use this ability if it has not used a Rampage ability this turn. Then, pick a point on the battlefield within 6" of this unit and pick each enemy unit within 3" of that point to be the targets. 
        Effect: Roll a D3 for each target. On a 2+, inflict an amount of mortal damage on that target equal to the roll.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Bellowing Mockery - Once Per Turn`,
        desc: `Declare: Pick this unit to use this ability if it has not used a Rampage ability this turn, then pick an enemy unit within this units combat range to be the target. 
        Effect: Roll a dice. On a 3+, subtract 1 from hit rolls for the targets attacks for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Whatre You Lookin At? - Once Per Turn`,
        desc: `Declare: Pick this unit to use this ability if it charged this turn and has not used a Rampage ability this turn. Then, pick an enemy unit within 9" of this unit to be the target. 
        Effect: Roll 2D6. This unit can move a number of inches equal to the roll. It can pass through enemy models and must end that move in combat with the target.`,
        when: [CHARGE_PHASE],
      },
    ],
  },
  'ROR: Bloodthirsty Shiver': {
    effects: [
      {
        name: `Hunt of the Bloodthirsty Shiver`,
        desc: `Effect: If both units in this Regiment of Renown are within each other's combat range, pick 1 of the following effects to apply until the start of your next turn:
        Evasive Approach: While both units in this Regiment of Renown are within each other's combat range, subtract 1 from hit rolls for attacks that target them.
        Ferocious Attack: While both units in this Regiment of Renown are within each other's combat range, their Allopex's Ferocious Bites have Crit (2 Hits).`,
        when: [HERO_PHASE],
      },
      {
        name: `Akhelian Allopex: Bloodthirsty Predators - Passive`,
        desc: `Effect: Add 1 to the Attacks characteristic of this units Allopexs Ferocious Bite while it is within 6" of any damaged enemy units or while it is within 6" of any enemy units that had any models slain in the same turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Akhelian Allopex: Ensnared`,
        desc: `Declare: Pick an enemy Monster or Cavalry unit that had any damage points allocated to it this turn by this units shooting attacks to be the target. 
        Effect: Roll a dice. On a 3+, until the start of your next turn, subtract 1 from the number of dice rolled when making charge rolls for the target, to a minimum of 1.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
  'ROR: Namarti Shore Raid': {
    effects: [
      {
        name: `In the Shadow of the Ethersea`,
        desc: `Declare: This ability must be useded to deploy this Regiment of Renown instead of the Deploy Unit ability or the Deploy Regiment ability.
        Effect: Set up the units in this Regiment of Renown in reserve in the ethersea. They have now been deployed.`,
        when: [DURING_SETUP],
      },
      {
        name: `Launch the Attack`,
        desc: `Declare: Pick each unit in this Regiment of Renown that is in the ethersea.
        Effect: Set up each unit on the battlefield wholly within 7" of a battlefield edge, more than 9" from all enemy units and within the combat range of another unit in this Regiment of Renown. Then, each unit can immediately move D3". The units cannot move into combat during any part of that move.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Akhelian Thrallmaster: Akhelian Insights - Passive`,
        desc: `Effect: Melee weapons used by friendly Namarti units have Crit (2 Hits) while they are wholly within 12" of this unit.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Akhelian Thrallmaster: Thrallmaster - Reaction: You declared a Fight ability for this unit`,
        desc: `Effect: Pick a friendly Namarti Thralls unit that has not used a Fight ability this turn and is within this units combat range to be the target. The target can be picked to use a Fight ability immediately after the Fight ability used by this unit has been resolved.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Namarti Reavers: Strike on the Move - Passive`,
        desc: `Effect: This unit can use Shoot abilities even if it used a Run or Retreat ability in the same turn.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Namarti Thralls: Sweeping Blows - Reaction: You declared a Fight ability for this unit`,
        desc: `Effect: If any damage points inflicted by attacks made as part of that Fight ability are allocated to any enemy units, subtract 1 from wound rolls for attacks made by those enemy units for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'ROR: Drekkis Privateers': {
    effects: [
      {
        name: `Cruising Into Position`,
        desc: `Declare: Pick all units in this Regiment of Renown that have not been deployed.
        Effect: Set up all of those units in reserve plying the winds. They have now been deployed.`,
        when: [DURING_SETUP],
      },
      {
        name: `You Call it Yours; I call it Mine - Passive`,
        desc: `Effect: Add 1 to hit rolls and wound rolls for shooting attacks made by units in this Regiment of Renown that target an enemy unit that is within 6" of an enemy unit that has an enhancement.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Daredevil Deployment`,
        desc: `Declare: Pick the Arkanaut Frigate in this Regiment of Renown to use this ability if it is plying the winds.
        Effect: Set up the Arkanaut Frigate anywhere on the battlefield more than 9" from all enemy units. Then, set up all other units in this Regiment of Renown wholly within 6" of the Arkanaut Frigate and more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `The Good Ship Aesling - Passive`,
        desc: `Effect: The AELSLING has a Health characteristic of 17 instead of 14.`,
        when: [DURING_GAME],
      },
      {
        name: `Drekki Flynt: Captain of the Aelsling`,
        desc: `Declare: Pick an Arkanaut Frigate in this unit's regiment to be the target. This unit can use this ability while in reserve, and the target can also be in reserve.
        Effect: The target has the Aelsling keyword. Add 1 to the Damage characteristic of the target's Boarding Weapons for the rest of the battle.`,
        when: [DURING_SETUP],
      },
      {
        name: `Drekki Flynt: She Can Handle It! - Passive`,
        desc: `Effect: You can reroll run rolls and charge rolls for the Aelsling while it is wholly within 12" of this unit.`,
        when: [MOVEMENT_PHASE, CHARGE_PHASE],
      },
      {
        name: `Drekki Flynt: Auxiliary Skyhook`,
        desc: `Declare: Pick an enemy Monster in combat with this unit to be the target. 
        Effect: Roll a D3. On a 2+: 
        inflict an amount of mortal damage on the target equal to the roll.
        Subtract 1 from wound rolls made for the target's attacks for the rest of the turn.`,
        when: [END_OF_TURN],
      },
      {
        name: `Arkanaut Frigate: Assault Boat`,
        desc: `Declare: This unit cannot use this ability if it is in combat or has used a RUN or Retreat ability this turn. Pick a number of units up to its Transport Capacity that are wholly within 6" of it, that are not in combat and that have not charged this turn to be the targets. Then, make a charge roll of 2D6. 
        Effect: Remove the targets from the battlefield. Then, this unit must move a distance up to the value of the charge roll and must end the move within 1/2" of a visible enemy unit. Then, set up the targets wholly within this unit's combat range. If this unit is in combat, the targets can be set up in combat and have Strike-First for the rest of the turn. This unit and the targets have charged.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Arkanaut Frigate: Transport Capacity - Passive`,
        desc: `Effect: This unit can transport up to 2 friendly Kharadron Overlords Infantry units with a combined model count of up to 12 (see Battle Traits).`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Arkanaut Frigate: Battle Damaged - Passive`,
        desc: `Effect: While this unit has 10 or more damage points, the Attacks characteristic of its Heavy Sky Ordnance is 3.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Arkanaut Frigate: Incoming! - Once Per Turn`,
        desc: `Declare: Pick an enemy unit that charged this turn and is in combat with this unit to be the target. 
        Effect: Roll a dice. On a 2+, inflict an amount of mortal damage on the target equal to the roll.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Arkanaut Frigate: Medium Bomb Racks`,
        desc: `Declare: Pick an enemy unit that does not have Fly and that this unit passed across this phase to be the target. 
        Effect: Roll 6 dice. For each 4+, inflict 1 mortal damage on the target.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Arkanaut Company: Grizzled Buccaneers - Once Per Turn`,
        desc: `Declare: Pick an enemy unit that charged this turn and is in combat with this unit to be the target.
        Effect: Roll a dice. On a 3+:
        This unit can immediately use a Shoot ability as if it were your shooting phase but all of its attacks must target the target enemy unit.
        For the rest of the phase, this unit's Privateer Heavy Weapons have Shoot in Combat.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'ROR: Sky-Port Profiteers': {
    effects: [
      {
        name: `Command Ability: Supplies Don't Come Cheap`,
        desc: `Declare: Pick a visible terrain feature within 18" of the Codewright in this Regiment of Renown. Each friendly unit wholly within 3" of that terrain feature is a target.
        Effect: Roll a D3 for each target. On a 2+, Heal (X) the target, where X is an amount equal to the roll.`,
        when: [HERO_PHASE],
      },
      {
        name: `Command Ability: No One Rides for Free`,
        desc: `Declare: Pick a friendly Infantry unit with up to 10 models that is wholly within 9" of the Codewright in this Regiment of Renown and not in combat to be the target.
        Effect: Remove the target from the battlefield, then set it up again on the battlefield more than 9" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Command Ability: Long-Range Support`,
        desc: `Declare: Pick an objective within 15" of the Codewright in this Regiment of Renown and that no friendly units are contesting. Each unit contesting that objective is a target.
        Effect: Roll a dice for each target. If the roll exceeds the target's Health characteristic, inflict an amount of mortal damage on the target equal to the roll.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Codewright: Advisory Role - Once Per Turn`,
        desc: `Declare: Pick up to 3 visible friendly Skyfarers units to be the targets. 
        Effect: Roll a dice for each target. On a 3+, pick 1 of the following effects to apply to that target for the rest of the turn: 
        Seek New Prospects: Add 5 to the targets control score. 
        Dont Argue With the Wind: Add 1 to run rolls and charge rolls for the target. 
        Theres No Trading With Some People: The target can use a Retreat ability and still use Shoot abilities later in the turn. In addition, no mortal damage is inflicted on the target by Retreat abilities.`,
        when: [HERO_PHASE],
      },
      {
        name: `Specialist Grundstok Ammunition - Once Per Turn - Reaction: You declared a Shoot ability for this unit`,
        desc: `Declare: Pick Shieldbreaker ammunition or Thunderdrakk ammunition.
        Effect: If all of the attacks made for that Shoot ability target the same enemy unit, after that Shoot ability has been resolved, roll a dice and add the number of damage points allocated to the target by that Shoot ability. If the roll is higher than the target's Control characteristic, apply the following effect to the target based on the ammunition type picked:
        Shieldbreaker: Ward rolls cannot be made for the target until the start of your next turn.
        Thunderdrakk: That target has a maximum control score of 1 until the start of your next turn.`,
        when: [SHOOTING_PHASE],
      },
    ],
  },
  'ROR: Mask of the Deceiver': {
    effects: [
      {
        name: `Masked in Plain Sight`,
        desc: `Declare: This unit must be deployed using this ability.
        Effect: Set up this unit in reserve incognito. It has now been deployed.`,
        when: [DURING_SETUP],
      },
      {
        name: `Bait and Switch`,
        desc: `Declare: This unit can use this ability if it is incognito. Pick this unit and a friendly Infantry Hero to be the targets. One target must be incognito and the other must be on the battlefield.
        Effect: Set up the incognito target wholly within 6" of the other target and not in combat. Then, remove the other target from the battlefield and set it up in reserve incognito.
        If this unit is destroyed, before removing it from play, set up the friendly incognito unit wholly within 6" of a battlefield edge and not in combat.`,
        when: [HERO_PHASE],
      },
      {
        name: `Forceful Command: Casting value of 6`,
        desc: `Declare: Pick a visible friendly unit wholly within 12" of this unit to be the target, then make a casting roll of 2D6.
        Effect: Until the start of your next turn:
        The target cannot use Move abilities.
        The target's melee weapons have Anti-charge (+1 Rend).`,
        when: [HERO_PHASE],
      },
    ],
  },
  'ROR: Sigil Convocation': {
    effects: [
      {
        name: `Cycle Manifestation: Casting value of 6`,
        desc: `Declare: Pick the Scinari Calligrave in this Regiment of Renown to cast this spell, pick 1 of the friendly Manifestation below that is not on the battlefield, then make a casting roll of 2D6.
        Sanctum of Amyntok
        Hyshian Twinstones
        Rune of Petrification
        Effect: If there is already a friendly Manifestation from the list above on the battlefield, it is immediately banished. Then, set up the Manifestation you picked within 1" of the caster and visible to them. If that Manifestation is a Sanctum of Amyntok, it must instead be set up wholly within 12" of the caster, more than 3" from all enemy units, and with its 3 parts touching each other so that they form a ring.`,
        when: [HERO_PHASE],
      },
      {
        name: `Swift Erasure - Reaction: Opponent declared a Spell ability`,
        desc: `Effect: Roll a dice for each friendly unit that was picked to be a target of that Spell ability and that is wholly within 12" of the Scinari Calligrave in this Regiment of Renown. On a 4+, that Spell ability has no effect on that unit.`,
        when: [HERO_PHASE],
      },
      {
        name: `Arcane Taxonomy - Once Per Turn`,
        desc: `Effect: Remove the Scinari Calligrave in this Regiment of Renown from the battlefield and set it up again on the battlefield wholly within 3" of a friendly Manifestation and more than 7" from all enemy units.`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `Sanctum of Amyntok - Sigil of Yngra - Passive`,
        desc: `Effect: While a friendly unit with a Health characteristic of 10 or less is wholly inside the ring formed by this Manifestation:
        That unit is not visible to enemy units.
        Enemy abilities that would target that unit must target this Manifestation instead.`,
        when: [DURING_GAME],
      },
      {
        name: `Hyshian Twinstones - Reservoir of Power - Passive`,
        desc: `Effect: Each time a unit (friendly or enemy) successfully casts a spell while it is within 12" of this Manifestation, give this Manifestation 1 arcane charge point.
        This Manifestation can have a maximum of 6 arcane charge points.`,
        when: [HERO_PHASE],
      },
      {
        name: `Hyshian Twinstones - Release Arcane Charge - Once Per Turn - Reaction: You declared a Spell or Unbind ability for a Lumineth Realm-Lords Wizard within 3" of this Manifestation`,
        desc: `Effect: Add this Manifestation's arcane charge points to the casting roll or unbinding roll. Then, reset this Manifestation's arcane charge points to 0.`,
        when: [HERO_PHASE],
      },
      {
        name: `Rune of Petrification - Turn to Stone`,
        desc: `Effect: Roll a D3 for each enemy unit within 6" of this Manifestation. On a 2+, inflict an amount of mortal damage on that enemy unit equal to the roll. If an enemy unit has 3 mortal damage inflicted on it by this ability, it has Strike-Last for the rest of the turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'ROR: Dawnrider Lance': {
    effects: [
      {
        name: `Blinding Charge - Once Per Turn`,
        desc: `Declare: Pick a unit in this Regiment of Renown that charged this turn. Then, pick an enemy Infantry unit within 1" of that unit to be the target.
        Effect: For the rest of the turn, ignore positive modifiers to save rolls for the target.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Masters of All Terrain - Passive`,
        desc: `Effect: Ignore negative modifiers to run rolls and charge rolls for units in this Regiment of Renown and to their Move characteristic.`,
        when: [MOVEMENT_PHASE, CHARGE_PHASE],
      },
      {
        name: `Vanari Dawnrider: Dawnrider Charge - Passive`,
        desc: `Effect: Add 1 to the Rend characteristic of this unit's Dawnrider Lances and Blades if it charged in the same turn.`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Vanari Lord Regent on Lightcourser: Lead the Charge - Passive`,
        desc: `Effect: You can reroll charge rolls for friendly Lumineth Realm-Lords units while they are wholly within 6" of this unit.`,
        when: [CHARGE_PHASE],
      },
      {
        name: `Vanari Lord Regent on Lightcourser: Purest Aetherquartz - Once Per Battle`,
        desc: `Effect: For the rest of the turn, add 1 to hit rolls for this unit's attacks and subtract 1 from hit rolls for attacks that target this unit.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'ROR: The Crimson Lash': {
    effects: [
      {
        name: `Site of Slaughter - Once Per Battle`,
        desc: `Effect: Pick an objective wholly outside friendly territory. That objective is considered by you to be the amphitheatre.`,
        when: [DURING_SETUP],
      },
      {
        name: `Finishing Moves - Passive`,
        desc: `Effect: While each model in a unit in this Regiment of Renown is contesting the amphitheatre:
        That unit's melee weapons have Crit (Mortal).
        If you control the amphitheatre, if the unmodified hit roll or wound roll for an attack that targets that unit is a 1-4, the attack fails and the attack sequence ends.`,
        when: [SHOOTING_PHASE, COMBAT_PHASE],
      },
      {
        name: `High Gladiatrix: Paragon of Slaughter - Once Per Turn`,
        desc: `Declare: Pick a visible friendly Daughters of Khaine Infantry unit wholly within 12" of this unit to be the target.
        Effect: If this unit is in combat, add 1 to the Rend characteristic of the target's melee weapons for the rest of the turn.
        If this unit is not in combat, roll a dice. On a 3+, add 1 to the Rend characteristic of the target's melee weapons for the rest of the turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Sisters of Slaughter: Dance of Death - Once Per Turn`,
        desc: `Declare: Pick an enemy unit that charged this turn and is in combat with this unit to be the target.
        Effect: Subtract 1 from hit rolls and wound rolls for the target's combat attacks for the rest of the turn.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'ROR: Khinerai Death Flight': {
    effects: [
      {
        name: `Fierce Competition - Passive`,
        desc: `Effect: Each time a unit in this Regiment of Renown uses an ability and any enemy models were slain by that ability, after that ability has been resolved, the unit that used that ability is pre-eminent and the other unit in this Regiment of Renown is overlooked.
        Weapons used by an overlooked unit in this Regiment of Renown have Crit (Auto-wound).`,
        when: [COMBAT_PHASE],
      },
      {
        name: `Khinerai Heartrenders: Fire and Flight - Once Per Turn - Reaction: You declared a Shoot ability for this unit`,
        desc: `Effect: After that Shoot ability has been resolved, this unit can move 2D6". It cannot move into combat during any part of that move.`,
        when: [SHOOTING_PHASE],
      },
      {
        name: `Khinerai Lifetakers: Fight and Flight - Once Per Turn`,
        desc: `Effect: If this unit is in combat, it can move 12". It can pass through the combat ranges of enemy units but cannot end that move in combat. Then, roll a D3 for each enemy unit that this unit passed across during that move. On a 2+, inflict an amount of mortal damage to that enemy that unit equal to the roll.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Units, 'unit')
